// extracted by mini-css-extract-plugin
export default {"ant-notification":"jaVV1","antNotification":"jaVV1","app-content":"rTNeu","appContent":"rTNeu","wrapper":"lvLuL","app-footer":"ocfz4","appFooter":"ocfz4"};